import { useEffect, useState } from "react";
import { api, proLink } from "@/api";

// Cache par slug pour éviter de recharger la marque du pro entre les écrans.
const _cache = {};

// Renvoie la marque blanche du pro associé au lien /devis/:slug courant.
// pro = { slug, company_name, logo_url, cgv_url, gdpr_url } ou null (client particulier -> Déco Ligot).
export function useProBranding() {
  const slug = proLink.get();
  const [pro, setPro] = useState(slug ? _cache[slug] || null : null);
  const [loading, setLoading] = useState(!!slug && !_cache[slug]);

  useEffect(() => {
    let done = false;
    if (!slug) { setPro(null); setLoading(false); return; }
    if (_cache[slug]) { setPro(_cache[slug]); setLoading(false); return; }
    setLoading(true);
    api.publicPro(slug)
      .then((p) => { if (done) return; _cache[slug] = p; setPro(p); })
      .catch(() => { if (!done) setPro(null); })
      .finally(() => { if (!done) setLoading(false); });
    return () => { done = true; };
  }, [slug]);

  return { pro, loading, isPro: !!pro };
}
